"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Divider = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var propsFilter_1 = require("../../library/propsFilter");
var SharkMorphContext_1 = require("../../providers/SharkMorphContext");
require("./divider.css");
var Divider = function (_a) {
    var _b = _a.margin, margin = _b === void 0 ? 'sm' : _b, _c = _a.orientation, orientation = _c === void 0 ? 'horizontal' : _c, _d = _a.color, color = _d === void 0 ? 'very-light-grey' : _d, props = __rest(_a, ["margin", "orientation", "color"]);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('divider', margin, orientation, color) }, (0, propsFilter_1.getAllDataProps)(props, (0, SharkMorphContext_1.useSharkMorphContext)()))));
};
exports.Divider = Divider;
//# sourceMappingURL=Divider.js.map